import React, {ReactElement} from 'react';
import icon from '@assets/images/medops/clinic_groups.svg';

const ClinicGroupsIcon = (props: any): ReactElement => {
  return <img src={icon} {...props} />;
};
export default ClinicGroupsIcon;
